import {DOMSH} from "lib/commons/xml/domsh";

export namespace GFX {
	export interface ILogicalRect {
		blockStart: number,
		blockEnd: number,
		blockSize: number
		inlineStart: number,
		inlineEnd: number,
		inlineSize: number
	}

	export interface IPoint {
		x: number;
		y: number;
	}

	export interface IRect {
		x: number;
		y: number;
		width: number,
		height: number
	}

	export function getLogicalRect(rect: ClientRect | DOMRect, inverseInline?: boolean, swapBlockAndInline?: boolean): ILogicalRect {
		if (swapBlockAndInline) {
			return {
				blockStart: rect.left,
				blockEnd: rect.right,
				blockSize: rect.width,
				inlineStart: inverseInline ? rect.bottom : rect.top,
				inlineEnd: inverseInline ? rect.top : rect.bottom,
				inlineSize: rect.height
			}
		} else {
			return {
				blockStart: rect.top,
				blockEnd: rect.bottom,
				blockSize: rect.height,
				inlineStart: inverseInline ? rect.right : rect.left,
				inlineEnd: inverseInline ? rect.left : rect.right,
				inlineSize: rect.width
			}
		}
	}

	/** Retourne BoundingRect d'un élément ou de son 1er ancêtre qui n'est pas hidden. */
	export function getContextBoundingRect(elt: HTMLElement): ClientRect | null {
		let r = elt.getBoundingClientRect();
		while (r.top === 0 && r.left === 0 && r.height === 0 && r.width === 0) {
			//Element masqué, on remonte.
			elt = DOMSH.getFlatParentElt(elt) as HTMLElement;
			if (!elt) return null; //echec
			r = elt.getBoundingClientRect();
		}
		return r;
	}

	export function getOffsetRect(elt: HTMLElement): ClientRect {
		return {
			top: elt.offsetTop,
			height: elt.offsetHeight,
			bottom: elt.offsetTop + elt.offsetHeight,
			left: elt.offsetLeft,
			width: elt.offsetWidth,
			right: elt.offsetLeft + elt.offsetWidth,
		}
	}

	export function getScrollRect(elt: HTMLElement): ClientRect {
		return {
			top: elt.scrollTop,
			height: elt.scrollHeight,
			bottom: elt.scrollTop + elt.scrollHeight,
			left: elt.scrollLeft,
			width: elt.scrollWidth,
			right: elt.scrollLeft + elt.scrollWidth,
		}
	}

	export function isPointIn(rect: DOMRect | ClientRect, x: number, y: number): boolean {
		return rect.left <= x && rect.right >= x && rect.top <= y && rect.bottom >= y;
	}

	// export function isIntersected(r1: DOMRect | ClientRect, r2: DOMRect | ClientRect) {
	// 	return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
	// }

	export function bound(min: number, val: number, max: number): number {return Math.max(min, Math.min(val, max))}

	export function intersect(r1: DOMRect | ClientRect, r2: DOMRect | ClientRect): DOMRect | null {
		const x1 = Math.max(r1.left, r2.left);
		const x2 = Math.min(r1.right, r2.right);
		if (x1 > x2) return null;
		const y1 = Math.max(r1.top, r2.top);
		const y2 = Math.min(r1.bottom, r2.bottom);
		return y1 > y2 ? null : new DOMRect(x1, y1, x2 - x1, y2 - y1);
	}

	export function vecLength(point1: IPoint, point2: IPoint) {
		return Math.hypot(point2.x - point1.x, point2.y - point1.y);
	}

	export function getContainerOrient(from: Element): 'v' | 'h' {
		let st = window.getComputedStyle(from);
		while (st.display === 'contents') {
			from = DOMSH.getFlatParentElt(from);
			st = window.getComputedStyle(from);
		}
		if (st.display === 'block' || st.display === 'table-cell' || st.display === 'list-item' || st.flexDirection === 'column' || st.flexDirection === 'column-reverse') return 'v';
		return 'h';
	}

}

export namespace SVG {
	export function assignRectLengths(svgElem: SVGRectElement, lengths: Partial<GFX.IRect>): void {
		for (const key in lengths) {
			svgElem[key as keyof GFX.IRect].baseVal.value = lengths[key as keyof GFX.IRect];
		}
	}
}
